import { Icon } from "@iconify/react";

interface FinalizeQuotationRequestButtonProps {
  isDarkMode: boolean;
  isLoading: boolean;
  selectedSessionId: string | null;
  onFinalizeQuotationRequest?: () => void;
}

export function FinalizeQuotationRequestButton({
  isDarkMode,
  isLoading,
  selectedSessionId,
  onFinalizeQuotationRequest,
}: FinalizeQuotationRequestButtonProps) {
  return (
    <button
      type="button"
      onClick={onFinalizeQuotationRequest}
      disabled={isLoading || !selectedSessionId}
      className={[
        "px-3",
        "py-2",
        "md:px-4",
        "md:py-2",
        "rounded-lg!",
        "grid",
        "grid-cols-[auto_1fr]",
        "place-items-center",
        "gap-2",
        "whitespace-nowrap",
        isDarkMode ? "bg-purple-600 hover:bg-purple-700" : "bg-purple-500 hover:bg-purple-600",
        isLoading || !selectedSessionId ? "opacity-50 cursor-not-allowed" : "",
        "text-white!",
        "text-sm",
        "md:text-base",
        "font-medium",
        "finalize-quotation-btn",
        "w-full",
        "md:w-auto",
      ].join(" ")}
      aria-label="Finalize Quotation Request"
    >
      <Icon icon="mdi:check-circle-outline" className="w-5 h-5 text-white!" />
      <span className="text-white!">Finalize Quotation Request</span>
    </button>
  );
}
